import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import BigHierarchyMultipicklistControl
  from 'Components/ComponentLibrary/Components/Inputs/Multipicklist/BigHierarchyMultipicklistControl';
import SurveyStepHeader from 'Views/Onboarding/Components/SurveyStepHeader';
import classNames from 'classnames';
import useMobileLayout from 'Hooks/useMobileLayout';
import {
  AccountBalance,
  CreditCard,
  DirectionsCar,
  Home,
  LocalCafe,
  LocalHospital,
  School,
  ShowChart,
  SignalCellularAlt,
  Timeline,
  VerifiedUser,
  Work,
} from '@material-ui/icons';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';


const styles = theme => ({
  root: {
    width: '100%',
    margin: 'auto',
    maxWidth: '400px',
    marginBottom: theme.spacing(10),
    padding: theme.spacing(2),
  },
  rootDesktop: {
    maxWidth: '600px',
  },
  surveyStepHeader: {
    padding: 0,
  },
  surveyStepHeaderTitle: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(4),
  },

});

const Content = ({
  classes,
}) => {
  const isMobile = useMobileLayout();
  const [options, setOptions] = useState([]);
  const [field, setField] = useState(undefined);
  const [isMultipicklist, setIsMultipicklist] = useState(false);
  const {
    resource,
    handleChange,
  } = useMetaLayoutContext();

  useScrollTopOnMount();

  useEffect(() => {
    const f = resource
      .meta()
      .template()
      .list()
      .filter(item => item.attr('type') === 'picklist' || item.attr('type') === 'multipicklist')[0];
    const multipicklist = f.attr('type') === 'multipicklist';

    setField(f);
    setIsMultipicklist(multipicklist);

    if (multipicklist) {
      setOptions(resource.attr(f.attr('name')));
    } else {
      setOptions([resource.attr(f.attr('name'))]);
    }
  }, [resource]);

  function handleLocalChange(name, value) {
    if (isMultipicklist) {
      setOptions(value);
      handleChange(name, value);
    } else {
      // We only allow the selection of one value, filter out the previous value
      const arr = value.filter(item => !options.includes(item));
      setOptions(arr);
      handleChange(name, arr[0]);
    }
  }

  const iconMapper = (groupName) => {
    switch (groupName) {
      case 'Retirement Accounts':
      case 'Non-retirement Account':
        return { icon: SignalCellularAlt, isLegacy: true };
      case 'Education Accounts':
      case 'Education Account':
        return { icon: School, isLegacy: true };
      case 'Brokerage Accounts':
      case 'Employer Sponsored Plan':
      case 'Non Retirement Account':
        return { icon: ShowChart, isLegacy: true };
      case 'Trust Accounts':
        return {
          icon: 'shield',
          isLegacy: false,
        };
      case 'Personal Retirement Account':
        return { icon: Timeline, isLegacy: true };
      case 'Bank Account':
      case 'Cash Accounts':
        return { icon: AccountBalance, isLegacy: true };
      case 'Liability':
        return { icon: CreditCard, isLegacy: true };
      case 'Health Savings Account':
        return { icon: LocalHospital, isLegacy: true };
      case 'Home':
        return { icon: Home, isLegacy: true };
      case 'Debt':
        return { icon: CreditCard, isLegacy: true };
      case 'Transportation':
        return { icon: DirectionsCar, isLegacy: true };
      case 'Insurance':
        return { icon: VerifiedUser, isLegacy: true };
      case 'Lifestyle':
        return { icon: LocalCafe, isLegacy: true };
      case 'Taxes':
        return { icon: Work, isLegacy: true };
      default:
        return null;
    }
  };

  return (
    <div className={classNames(classes.root, {
      [classes.rootDesktop]: !isMobile,
    })}
    >
      <SurveyStepHeader
        title={resource.attr('title') || resource.attr('primaryText')}
        titleTest="wizard-step-title"
        classes={{
          root: classes.surveyStepHeader,
          title: classes.surveyStepHeaderTitle,
        }}
      />
      <BigHierarchyMultipicklistControl
        options={field ? field.options().list() : []}
        value={options}
        onChange={(value) => {
          return handleLocalChange(field.attr('name'), value);
        }}
        iconMapper={iconMapper}
      />
    </div>
  );
};

Content.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Content);
